import { gql } from "@apollo/client";

export const QUERY_NOTIFICATIONS = gql`
  query notifications(
    $filters: NotificationFiltersInput
    $pagination: PaginationArg
    $sort: [String]
    $schoolContextDocumentId: ID!
  ) {
    notifications_connection(
      filters: $filters
      pagination: $pagination
      sort: $sort
      status: PUBLISHED
    ) {
      nodes {
        documentId
        link
        isCustom
        priority
        customTemplate
        createdAt
        publishedAt
        template {
          documentId
          type
          category
          template
        }
        resource {
          documentId
          title
          slug
          cover {
            url
            alternativeText
          }
        }
        schools {
          documentId
          name
        }
      }
      pageInfo {
        page
        pageSize
        pageCount
        total
      }
    }
  }
`;

export const QUERY_NOTIFICATION_BY_ID = gql`
  query notificationById($documentId: ID!) {
    notification(documentId: $documentId) {
      documentId
      link
      isCustom
      priority
      customTemplate
      createdAt
      publishedAt
      template {
        documentId
        type
        category
        template
      }
      resource {
        documentId
        title
        slug
        cover {
          url
          alternativeText
        }
      }
      schools {
        documentId
        name
      }
    }
  }
`;

export const QUERY_USER_NOTIFICATIONS = gql`
  query userNotifications(
    $filters: NotificationUserFiltersInput
    $pagination: PaginationArg
    $sort: [String]
  ) {
    notificationUsers_connection(
      filters: $filters
      pagination: $pagination
      sort: $sort
    ) {
      nodes {
        documentId
        deliveredAt
        clickedAt
        seenAt
        notification {
          documentId
          link
          isCustom
          priority
          customTemplate
          createdAt
          publishedAt
          template {
            documentId
            type
            category
            template
          }
          resource {
            documentId
            title
            slug

            cover {
              url
              alternativeText
            }
          }
        }
      }
      pageInfo {
        page
        pageSize
        pageCount
        total
      }
    }
  }
`;

export const QUERY_UNREAD_NOTIFICATIONS_COUNT = gql`
  query unreadNotificationsCount($filters: NotificationUserFiltersInput) {
    notificationUsers_connection(filters: $filters) {
      pageInfo {
        total
      }
    }
  }
`;

export const QUERY_NOTIFICATION_TEMPLATES = gql`
  query notificationTemplates(
    $filters: NotificationTemplateFiltersInput
    $pagination: PaginationArg
    $sort: [String]
  ) {
    notificationTemplates_connection(
      filters: $filters
      pagination: $pagination
      sort: $sort
    ) {
      nodes {
        documentId
        type
        category
        template
        createdAt
      }
      pageInfo {
        page
        pageSize
        pageCount
        total
      }
    }
  }
`;
